import echarts from 'echarts/lib/echarts';
import tool from './util';

export default {
    concreteCardData(at3trend,at3summary) {
        let baseInfo = at3trend.AT3BasicInfo;
        let vecvec = at3trend.vecvecNetCurve && at3trend.vecvecNetCurve.length > 0 ? at3trend.vecvecNetCurve : [[],[]];

        let lineBase = [],
            lineStrategy = [];

        for (let i = 0, length = vecvec[0].length; i < length; i++) {
            lineStrategy.push([vecvec[0][i].dtDate, (+vecvec[0][i].dbNetValue).toFixed(4)]);
            lineBase.push([vecvec[1][i].dtDate, (+vecvec[1][i].dbNetValue).toFixed(4)]);
        }

        // 组装数据
        let strategy = {
            ...baseInfo,

            dbAccProfitP: tool.transformPercentNumber(at3summary.dbIninCashReturn), //累计收益率
            dbAnnuReturnRate: tool.transformPercentNumber(at3summary.dbAnnuReturnRate), //年化收益
            dbMaxDrawBackP: tool.transformPercentNumber(baseInfo.dbMaxDrawBackP), //最大回撤

            xData: [
                {
                    name: '策略收益',
                    type: 'line',
                    // symbol: 'circle', //数据点标记，会影响legend标记图形
                    showSymbol: false, //是否在线条上显示数据点标记
                    zlevel: 2, //决定z轴覆盖顺序
                    color: '#FF6A60',
                    lineStyle: {
                        width: 1.5,
                    },
                    smooth: true, // 是否让曲线做平滑处理
                    // stack: '总量',
                    areaStyle: { normal: {
                        // 渐变
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#FF6A60', //start color
                        }, {
                            offset: 1,
                            color: '#fff', // end color
                        }])
                    }}, //曲线覆盖区域央视
                    data: lineStrategy
                },
                {
                    name: '基准收益',
                    type: 'line',
                    // symbol: 'circle',
                    showSymbol: false,
                    zlevel: 1,
                    color: '#487AFF',
                    lineStyle: {
                        width: 1.5,
                    },
                    smooth: true,
                    areaStyle: { normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#487AFF',
                        }, {
                            offset: 1,
                            color: '#DBE4FE',
                        }])
                    }},
                    data: lineBase
                },

            ], // xData

        };

        return strategy;
    },

    concretePrivateCardData(item) {
        let at3trend = item.sPRAT3WholeInfo.AT3Trend;
        let baseInfo = at3trend.AT3BasicInfo;
        let vecvec = at3trend.vecvecNetCurve && at3trend.vecvecNetCurve.length > 0 ? at3trend.vecvecNetCurve : [[],[]];

        let lineBase = [],
            lineStrategy = [];

        for (let i = 0, length = vecvec[0].length; i < length; i++) {
            lineBase.push([vecvec[0][i].dtDate, (+vecvec[0][i].dbNetValue).toFixed(4)]);
            lineStrategy.push([vecvec[1][i].dtDate, (+vecvec[1][i].dbNetValue).toFixed(4)]);
        }

        // 组装数据
        let strategy = {

            ...item.sCloudStrategyInfo,

            ...baseInfo,

            // dbAccProfitP: (+baseInfo.dbAccProfitP).toFixed(2) + '%', //累计收益率
            // dbAnnuReturnRate: (+baseInfo.dbAnnuReturnRate).toFixed(2) + '%', //年化收益
            // dbMaxDrawBackP: (+baseInfo.dbMaxDrawBackP).toFixed(2) + '%', //最大回撤

            xData: [
                {
                    name: '策略收益',
                    type: 'line',
                    symbol: 'circle', //数据点标记，会影响legend标记图形
                    showSymbol: false, //数据点标记
                    zlevel: 2, //决定z轴覆盖顺序
                    color: '#D9534F',
                    lineStyle: {
                        width: 1.5,
                    },
                    // smooth: true,
                    // stack: '总量',
                    areaStyle: { normal: {
                        // 渐变
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#D9534F', //start color
                        }, {
                            offset: 1,
                            color: '#33333A', // end color
                        }])
                    }}, //曲线覆盖区域央视
                    data: lineBase
                },
                {
                    name: '基准收益',
                    type: 'line',
                    symbol: 'circle',
                    showSymbol: false,
                    zlevel: 1,
                    color: '#5BC0DE',
                    lineStyle: {
                        width: 1.5,
                    },
                    areaStyle: { normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#5BC0DE',
                        }, {
                            offset: 1,
                            color: '#33333A',
                        }])
                    }},
                    data: lineStrategy
                },

            ], // xData

        };

        return strategy;
    },

    // 解析数据->判断数据是否有错
    resolveRes(res, opt) {
        return new Promise((resolve, reject) => {
            let data = res.data.msgBody;
            let err  = data.err;
            switch(parseInt(err.level)) {
                case 0:
                case 1: // 提示
                case 2: // 警告
                    resolve(data);
                    break;
                case 3: // 错误
                    reject({
                        type: 'serverError',
                        showError: true,
                        message: err.msg,
                    });
                    break;
                default:
                    reject({
                        type: 'serverError',
                        showError: false,
                        message: '无效错误级别：' + (+err.level),
                    });
                    break;
            }
        });
    },

    // 构建策略曲线数据
    configureOption(data){
        const { xData } = data;
        const legendData = xData.map(item=>{
            const { name,color } = item;
            return {
                name,
                textStyle:{
                    color
                }
            }
        })
        const option = {
            backgroundColor: '#fff',

            title: {
                text: '',
                show: false,
            },
            legend: {
                show: true,
                top: '0%',
                right: '0%',
                textStyle: {
                    color: '#fff',
                },
                data: legendData,
            },
            
            grid: {
                top: '16%',
                left: '0%',
                right: '0%',
                bottom: '0%',
                containLabel: true,
                show: true,
                borderWidth: '0',
                borderColor: '#000',
                backgroundColor: '#fff',
            },
            tooltip : {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: { // 鼠标移入是x轴的标签样式
                        show: false,
                    }
                }
            },
            xAxis: [
                {
                    type : 'time', //time的时候可以在serise中[date, data]的方式放数据，category时要在本对象中的data中放入类目数组，serise元素为单个数据

                    axisTick: { // 坐标轴刻度
                        show: false,
                        inside: true, //刻度显示位置
                    },
                    axisLabel: { // 坐标轴刻度文字
                        // interval: 0, //category有效，强制显示所有横轴
                        color: '#999',
                        fontSize: 11,
                        showMinLabel: false, //是否显示最小值
                    },
                    axisLine: { // X、Y轴的主轴线
                        show: true,
                        lineStyle: {
                            color: 'rgba(0,0,0,.05)', //对坐标轴文字同样有效
                        }
                    },
                    splitLine: { //轴分割线
                        show: true, 
                        lineStyle: {
                            color: 'rgba(0,0,0,.05)',
                        }
                    },
                    scale: true, //放大效果
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    position: 'left',
                    name: '累计收益率',
                    nameLocation: 'middle',

                    axisTick: {
                        show: false,
                        inside: true,
                    },
                    axisLabel: {
                        color: '#999',
                        fontSize: 10,
                        inside: false, // 标签是否放在格子里面
                        showMinLabel: false,
                    },
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: 'rgba(0,0,0,.05)',
                        }
                    },
                    splitLine: {
                        show: true, 
                        lineStyle: {
                            color: 'rgba(0,0,0,.05)',
                        }
                    },
                    scale: true,
                }
            ],
            series: xData,
        };
        return option;
    }
}